import { Button, Container, Typography } from '@cleartrip/ct-design-components'

import EmiBanksError from '@/assets/svg/EmiBanksError'
import { EMI_BANKS_ERROR_MESSAGE, EMI_BANKS_RETRY_MESSAGE } from '@/constants/Emi'

interface EmiOptionsErrorProps {
  handleRetry?: () => void
}

const EmiOptionsError = ({ handleRetry }: EmiOptionsErrorProps) => {
  const onRetry = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (typeof handleRetry === 'function') {
      handleRetry()
    }
  }
  return (
    <Container className='flex-1 flex flex-middle flex-center'>
      <Container className='flex flex-column flex-middle'>
        <EmiBanksError />
        <Typography className='mt-2' variant='HM2'>
          {EMI_BANKS_ERROR_MESSAGE}
        </Typography>
        <Button className='c-pointer mt-6' color='primary' size='medium' variant='contained' onClick={onRetry}>
          {EMI_BANKS_RETRY_MESSAGE}
        </Button>
      </Container>
    </Container>
  )
}

export default EmiOptionsError
